import styled from 'styled-components'

export const CheckboxGridStyled = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  column-gap: ${({ theme }) => theme.space.large};
  row-gap: ${({ theme }) => theme.space.medium};
`
